import { Controller } from '@hotwired/stimulus'
import { getCsrfParamsAsObject } from '~/common/helpers/csrf'

export default class extends Controller {
  static targets = ['startedAtField']

  static values = { objectViewId: String }

  connect() {
    this.hasStarted = false

    // input  - Catches typing, pasting, drag & drop, programmatic changes, and custom components
    // change - Catches dropdown selections, file uploads completing, radio/checkbox changes
    this.element.addEventListener('input', this.handleInput)
    this.element.addEventListener('change', this.handleInput)
  }

  disconnect() {
    this.removeEventListeners()
  }

  handleInput = (event) => {
    if (this.hasStarted) return
    if (event.target.type === 'hidden' || event.target.type === 'submit') return

    this.recordInputStart()
  }

  async recordInputStart() {
    if (!this.objectViewIdValue) return

    this.hasStarted = true

    // Remove event listeners since we no longer need them
    this.removeEventListeners()

    try {
      // Create InputStart record via AJAX
      const response = await fetch('/input_starts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          ...getCsrfParamsAsObject(),
          input_start: {
            object_view_id: this.objectViewIdValue,
          },
        }),
      })

      if (response.ok) {
        const data = await response.json()
        // Set the started_at timestamp from the server response
        if (this.hasStartedAtFieldTarget && data.created_at) {
          this.startedAtFieldTarget.value = data.created_at
        }
      }
    } catch (error) {
      console.error('Failed to record input start:', error)
    }
  }

  removeEventListeners() {
    this.element.removeEventListener('input', this.handleInput)
    this.element.removeEventListener('change', this.handleInput)
  }
}
